export default __webpack_public_path__ + "fd9f2d64f094a26a2184ecd50df62535.png";